import request from '@/api/request.js'

// 新增
export function UserVSRoleInsert(data) {
    return request({
        url: '/api/user/uservsroleinsert',
        method: 'post',
        data: data
    })
}

// 新增
export function UserVSRoleInsertMany(data) {
    return request({
        url: '/api/user/uservsroleinsertmany',
        method: 'post',
        data: data
    })
}

// 删除
export function UserVSRoleDelete(id) {
    return request({
        url: `/api/user/uservsroledelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function UserVSRoleUpdate(id, data) {
    return request({
        url: `/api/user/uservsroleupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function UserVSRoleGetById(id) {
    return request({
        url: `/api/user/getuservsrolebyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function UserVSRoleGetList(params) {
    return request({
        url: '/api/user/getuservsrolelist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function UserVSRoleGetPageList(params) {
    return request({
        url: '/api/user/getuservsrolepagelist',
        method: 'get',
        params: params
    })
}